import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { parse } from 'qs'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'
import { Box, Container, Typography } from '@mui/material'

import { setLeaves } from '../../slices'
import { AdministrativeLeavesTable } from '../table'
import { AdministrativeLeavesFilter } from '../filter'
import { administrativeLeavesDashboardStyles } from './administrative-leaves-dashboard.styles'
import { LEAVES_DEFAULT_QUERY } from '../../constants'

export const AdministrativeLeavesDashboard = withStyles(administrativeLeavesDashboardStyles)(({
  classes,
}) => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const marketerId = useSelector((state) => state.global.comercializadora_id)
  //Acquire url and parse its search options
  const url = useLocation().search
  const urlSearchParams = parse(url.split('?')[1])
  const searchParams = {
    ...LEAVES_DEFAULT_QUERY,
    ...urlSearchParams,
  }
  useEffect(() => {
    dispatch(setLeaves(searchParams, marketerId))
  }, [url]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <Container className={classes.container} maxWidth="lg">
        <Box mb={2}>
          <Typography variant="h4" color="textSecondary">
            {formatMessage({ id: 'pages.administrativeLeaves.title' })}
          </Typography>
        </Box>
        <Box mb={2}>
          <AdministrativeLeavesFilter />
        </Box>
        <Box>
          <AdministrativeLeavesTable />
        </Box>
      </Container>
    </Box>
  )
})
